const hitlRejectionMarkers = [
  '[HITL REJECTION]',
  'human-in-the-loop user rejected',
  'human in the loop user rejected',
] as const;

export function containsHITLRejectionMarker(value: unknown): boolean {
  if (typeof value === 'string') {
    const normalizedValue = value.toLowerCase();

    return hitlRejectionMarkers.some((marker) =>
      normalizedValue.includes(marker.toLowerCase()),
    );
  }

  if (Array.isArray(value)) {
    return value.some((item) => containsHITLRejectionMarker(item));
  }

  if (value && typeof value === 'object') {
    return Object.values(value).some((item) =>
      containsHITLRejectionMarker(item),
    );
  }

  return false;
}
